import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/communities";

export const communitiesApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (slug: string) => apiGet<{ community: Record<string, unknown> }>(`${BASE}/${slug}`),

  create: (data: Record<string, unknown>) => apiPost<{ community: Record<string, unknown> }>(BASE, data),

  update: (slug: string, data: Record<string, unknown>) =>
    apiPut<{ community: Record<string, unknown> }>(`${BASE}/${slug}`, data),

  delete: (slug: string) => apiDelete<{ message: string }>(`${BASE}/${slug}`),

  join: (slug: string) => apiPost<{ message: string }>(`${BASE}/${slug}/join`),

  leave: (slug: string) => apiPost<{ message: string }>(`${BASE}/${slug}/leave`),

  getMembers: (slug: string) => apiGet<{ members: Record<string, unknown>[] }>(`${BASE}/${slug}/members`),
};
